import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { authReducer, AUTH_INITIAL_STATE } from './auth/auth.reducer';
import { AuthEffects } from './auth/auth.effects';
import { AutoLogoutComponent } from './auth/auto-logout-confirmation/auto-logout.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { WebAngularSharedUtilErrorHandlingModule } from '@content-platform/web-angular-shared-util-error-handling';

import { HandleAdCallbackResolver } from './handle-ad-callback.resolver';
import { AdAuthGuard } from './ad-auth.guard';
import { NotificationsModule } from '@content-platform/web-angular-shared-ui-notifications';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { AuthLoggingTransformer } from './auth-logging-transformer';
import { AuthReportTransformer } from './auth-report-transformer';
import { AuthDebugFlags } from './debug-flags';
import { MinutesSecondsPipe } from './minutes-seconds.pipe';

/**
 * AuthModule which includes the auth reducer and effects
 *
 * @export
 * @class AuthModule
 */
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('auth', authReducer, { initialState: AUTH_INITIAL_STATE }),
    EffectsModule.forFeature([AuthEffects]),
    MatSnackBarModule,
    LoggingModule.withExtraParams([AuthLoggingTransformer]),
    HttpClientModule,
    NotificationsModule,
    WebAngularSharedUtilErrorHandlingModule.withExtraParams(AuthReportTransformer),
    DevelopmentModule.withFlags(AuthDebugFlags),
    MatDialogModule,
    MatButtonModule
  ],
  providers: [AuthEffects, HandleAdCallbackResolver, AdAuthGuard],
  declarations: [AutoLogoutComponent, MinutesSecondsPipe],
  entryComponents: [AutoLogoutComponent],
  exports: []
})
export class AuthModule {}
